import { createContext, useContext } from 'react'
import type { OnboardingLayoutContext_ReferralFragment } from './useOnboardingLayoutContext.graphql'
import type { SignupInterestsEnum, FlowTypeEnum } from 'gql/types'

export interface OnboardingLayoutContext {
  interestedIn: SignupInterestsEnum[]
  referrer?: OnboardingLayoutContext_ReferralFragment | null
  flowType?: FlowTypeEnum | null
  isSimplifiedFlow?: boolean
}

const OnboardingLayoutContext = createContext<OnboardingLayoutContext>({
  interestedIn: [],
  referrer: null,
  flowType: null,
  isSimplifiedFlow: false,
})

export interface OnboardingLayoutProviderProps {
  interestedIn: OnboardingLayoutContext['interestedIn']
  referrer?: OnboardingLayoutContext['referrer']
  flowType?: OnboardingLayoutContext['flowType']
  isSimplifiedFlow?: OnboardingLayoutContext['isSimplifiedFlow']
}

export const OnboardingLayoutProvider: Settle.FC<OnboardingLayoutProviderProps> = ({
  children,
  interestedIn,
  referrer = null,
  flowType = null,
  isSimplifiedFlow = false,
}) => (
  <OnboardingLayoutContext.Provider value={{ interestedIn, referrer, flowType, isSimplifiedFlow }}>
    {children}
  </OnboardingLayoutContext.Provider>
)

export const useOnboardingLayoutContext = () => useContext(OnboardingLayoutContext)
